// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__7aKpb","closeModalIcon":"PopUpModal_closeModalIcon__ew1dm"};